import React from 'react';
import { Table, Alert } from 'reactstrap';
import { DistributorUsageEntry }  from './DistributorUsageEntry'
import { Distributor } from 'logic/apiCalls';

import css from './DistributorsUsageEntries.module.scss';

type DistributorUsageEntriesProps = {
    distributors: Distributor[], 
    handleDownload: (distributorToUpdate: Distributor) => void,
    handleLineChart: (distributorToUpdate: Distributor) => void,
}

export const DistributorUsageEntries = ({ distributors, handleDownload, handleLineChart } : DistributorUsageEntriesProps) => {

    if (distributors.length === 0) {
        return <Alert color='warning'>
            No distributors are configured
        </Alert>
    }

    return (
        <div className={css.distributorTable}>
            <Table className="table-striped">
                <thead className="thead-dark">
                    <tr className="d-flex">
                        <th className="col-3">Id</th>                        
                        <th className="col-3">Name</th>
                        <th className="col-3">Azure Id</th>                        
                        <th className="col-3"></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        distributors.map((value) => {
                            return <DistributorUsageEntry key={value.id} distributor={value} handleDownload={handleDownload} handleLineChart={handleLineChart}/>
                        })
                    }
                </tbody>
            </Table>
        </div>
    )
}